/*
 * @描叙: 抄控管理
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-01-30 16:30:32 
*/

import { $post,$get } from '@/utils/http'
import Service from './Service'

// 获取设备分组
Service.getMeterGroupList = async function () {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    let data = await $post('/ucenter/v2/devices/listdevgroup', request, true);
    return Service.handleCommonError(data)
}

// 获取设备列表
Service.getMeterDeviceList = async function (params) {
    let request = {}
    // 项目Id
    request['project_system_id'] = Service.getProjectSystemId();
    if (!request['project_system_id']) return;

    // 表记序列号
    request['device_serial'] = params.device_serial;
    // 表记类型（1当量温控器，2风柜，3热量表）
    request['dev_type'] = params.devtype;
    // 建筑id
    request['building_id'] = params.moduleid;
	// 建筑id
	request['is_house'] = params.is_house;
	// 建筑id
	request['page_num'] = 1;
	// 建筑id
	request['page_sum'] = 1000;

    let data = await $get('/ucenter/v2/devices/listdev', request);
    return Service.handleCommonError(data)
}

// 获取id设备分组信息
Service.getMeterGroupInfo = async function (params) {
    let request = {}

    // 	设备分组id
    request['oid'] = params.OID;

    let data = await $post('/ucenter/v2/devices/devgroup', request, true);
    return Service.handleCommonError(data)
}

// 	添加设备分组
Service.addMeterGroup = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 	组名
    request['groupname'] = params.groupname;
    // 	备注
    request['description'] = params.description;
    // 	设备类型
    request['devtype'] = params.devtype;

    let data = await $post('/ucenter/v2/devices/adddevgroup', request);
    return Service.handleCommonError(data)
}

// 	编辑设备分组
Service.editMeterGroup = async function (params) {
    let request = {}

    // 	设备分组id
    request['oid'] = params.oid;
    // 	组名
    request['groupname'] = params.groupname;
    // 	设备类型
    request['devtype'] = params.devtype;
    // 	备注
    request['description'] = params.description;

    let data = await $post('/ucenter/v2/devices/editdevgroupname', request);
    return Service.handleCommonError(data)
}

// 	编辑设备分组表计信息
Service.editDevGroupMeter = async function (params) {
    let request = {}

    // 	设备分组id
    request['oid'] = params.OID;
    // 	设备ID集合
    request['devices'] = JSON.stringify(params.devices);

    let data = await $post('/ucenter/v2/devices/editdevgrouplist', request);
    return Service.handleCommonError(data)
}

// 删除设备分组
Service.deleteMeterGroup = async function (params) {
    let request = {}

    // 	设备分组id
    request['oid'] = params.OID;

    let data = await $post('/ucenter/v2/devices/deldevgroup', request);
    return Service.handleCommonError(data)
}


// 群控
// 按设备分组控制
Service.controlByGroup = async function (params) {
    let request = {}

    // 	状态
    request['setting_power_on'] = params.status;
    // 	模式
    request['setting_mode'] = params.module;
    // // 	制热温度
    // request['setting_heating_temperature'] = params.heatingtemperture ;
    // // 	制冷温度
    // request['setting_cooling_temperature'] = params.cryogenictempertur;
    // 	锁定
    request['setting_key_lock'] = params.lock;
    // 	来电启动状态
    request['setting_op_at_acback'] = params.callstartstate;
    // //  设置温度下限
    // request['setting_temperature_dl'] = params.upperlimit;
    // //  设置温度上限
    // request['setting_temperature_ul'] = params.lowerlimit;
    // 	通风模式使能
    request['setting_allow_ventilation'] = params.ventilationmodeenables;
    //  设备分组ID 集合
    request['goupidlist'] = params.goupidlist;
    let data = await $post('/ucenter/v2/devices/controlbygroup', request);
    return Service.handleCommonError(data)
}

// 按集控器控制
Service.ControlByCollectorID = async function (params) {
    let request = {}

    // 	状态
    request['setting_power_on'] = params.status;
    // 	模式
    request['setting_mode'] = params.module;
    // 	制热温度
    let tmp = params.heatingtemperture == "" ? "" : params.heatingtemperture * 10 + ""
    request['setting_heating_temperature'] = tmp;
    // 	制冷温度
    let tmp2 = params.cryogenictempertur == "" ? "" : params.cryogenictempertur * 10 + ""
    request['setting_cooling_temperature'] = tmp2;
    // 	锁定
    request['setting_key_lock'] = params.lock;
    // 	来电启动状态
    request['setting_op_at_acback'] = params.callstartstate;
    // //  设置温度下限
    // request['setting_temperature_dl'] = params.upperlimit;
    // //  设置温度上限
    // request['setting_temperature_ul'] = params.lowerlimit;
    // 	通风模式使能
    request['setting_allow_ventilation'] = params.ventilationmodeenables;
    //  设备分组ID 集合
    request['collectorlist'] = params.collectorlist;
   
    let data = await $post('/ucenter/v2/devices/controlbygroup', request);
    return Service.handleCommonError(data)
}

// 按所有风盘控制
Service.controlByTye = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 	状态
    request['setting_power_on'] = params.status;
    // 	模式
    request['setting_mode'] = params.module;
    
    if(params.devtype == 1) {
        // 	设置温度
        let tmp = params.setTemperature == "" ? "" : params.setTemperature * 10 + ""
        request['setting_heating_temperature'] = tmp;
        // 	风速
        request['setting_cooling_temperature'] = params.windSpeed;
    }
    if (params.devtype == 2) {
        // 	制热温度
        let tmp = params.heatingtemperture == "" ? "" : params.heatingtemperture * 10 + ""
        request['setting_heating_temperature'] = tmp;
        // 	制冷温度
        let tmp2 = params.cryogenictempertur == "" ? "" : params.cryogenictempertur * 10 + ""
        request['setting_cooling_temperature'] = tmp2;
    }

    // 	锁定
    request['setting_key_lock'] = params.lock;
    // 	来电启动状态
    request['setting_op_at_acback'] = params.callstartstate;
    //  设置温度下限
    // request['setting_temperature_dl'] = params.upperlimit;
    //  设置温度上限
    // request['setting_temperature_ul'] = params.lowerlimit;
    // 	通风模式使能
    request['setting_allow_ventilation'] = params.ventilationmodeenables;
    //  控制类型（1风盘，2风柜）
    request['devtype'] = params.devtype;
    let data = await $post('/ucenter/v2/devices/controlbytye', request);
    return Service.handleCommonError(data)
}

// 按楼宇结构控制
Service.controlByMidlist = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 	状态
    request['setting_power_on'] = params.status;
    // 	模式
    request['setting_mode'] = params.module;

    if (params.devtype == 1) {
        // 	设置温度
        let tmp = params.setTemperature == "" ? "" : params.setTemperature * 10 + ""
        request['setting_heating_temperature'] = tmp;
        // 	风速
        request['setting_cooling_temperature'] = params.windSpeed;
    }
    if (params.devtype == 2) {
        // 	制热温度
        let tmp = params.heatingtemperture == "" ? "" : params.heatingtemperture * 10 + ""
        request['setting_heating_temperature'] = tmp;
        // 	制冷温度
        let tmp2 = params.cryogenictempertur == "" ? "" : params.cryogenictempertur * 10 + ""
        request['setting_cooling_temperature'] = tmp2;
    }

    // 	锁定
    request['setting_key_lock'] = params.lock;
    // 	来电启动状态
    request['setting_op_at_acback'] = params.callstartstate;
    //  设置温度下限
    // request['setting_temperature_dl'] = params.upperlimit;
    //  设置温度上限
    // request['setting_temperature_ul'] = params.lowerlimit;
    // 	通风模式使能
    request['setting_allow_ventilation'] = params.ventilationmodeenables;
    //  建筑id列表
    request['moduleidlist'] = params.midlist;
    let data = await $post('/ucenter/v2/devices/controlbymidlist', request);
    return Service.handleCommonError(data)
}


// 单个表计控制
Service.controlByTerminalID = async function (params) {
    let request = {}
    // 表计ID
    request['terminalid'] = params.terminalid

    // 	状态
    request['setting_power_on'] = params.status;
    // 	模式
    request['setting_mode'] = params.module;

    if (params.devtype == 1) {
        // 	设置温度
        let tmp = params.setTemperature == "" ? "" : params.setTemperature * 10 + ""
        request['setting_heating_temperature'] = tmp;
        // 	风速
        request['setting_cooling_temperature'] = params.windSpeed;
    }
    if (params.devtype == 2) {
        // 	制热温度
        let tmp = params.heatingtemperture == "" ? "" : params.heatingtemperture * 10 + ""
        request['setting_heating_temperature'] = tmp;
        // 	制冷温度
        let tmp2 = params.cryogenictempertur == "" ? "" : params.cryogenictempertur * 10 + ""
        request['setting_cooling_temperature'] = tmp2;
    }

    // 	锁定
    request['setting_key_lock'] = params.lock;
    // 	来电启动状态
    request['setting_op_at_acback'] = params.callstartstate;
    //  设置温度下限
    // request['setting_temperature_dl'] = params.upperlimit;
    //  设置温度上限
    // request['setting_temperature_ul'] = params.lowerlimit;
    // 	通风模式使能
    request['setting_allow_ventilation'] = params.ventilationmodeenables;
    
    let data = await $post('/ucenter/v2/devices/controlbytid', request);
    return Service.handleCommonError(data)
}

// 按表计ID集合控制
Service.controlByOids = async function (params) {
    let request = {}

    // 	状态
    request['setting_power_on'] = params.status;
    // 	模式
    request['setting_mode'] = params.module;
    // // 	制热温度
    // request['setting_heating_temperature'] = params.heatingtemperture ;
    // // 	制冷温度
    // request['setting_cooling_temperature'] = params.cryogenictempertur;
    // 	锁定
    request['setting_key_lock'] = params.lock;
    // 	来电启动状态
    request['setting_op_at_acback'] = params.callstartstate;
    // //  设置温度下限
    // request['setting_temperature_dl'] = params.upperlimit;
    // //  设置温度上限
    // request['setting_temperature_ul'] = params.lowerlimit;
    // 	通风模式使能
    request['setting_allow_ventilation'] = params.ventilationmodeenables;
    //  设备分组ID 集合
    request['tidlist'] = params.tidlist;
    let data = await $post('/ucenter/v2/devices/controlbytidlist', request);
    return Service.handleCommonError(data)
}

// 5-9新增群控系统 FC109R控制

// 	群控项目下的FC109R
Service.controlfc109rbypid = async function (params) {
    let request = {}

    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 	状态
    request['power_on'] = params.power_on;
    // 	模式
    request['speed'] = params.speed;
    //  模式
    request['mode'] = params.mode;
    if (params.temperature != '' && params.temperature>0) {
        // 	设置温度
        request['temperature'] = params.temperature;
    }
    // 	通风模式使能
    request['key_lock'] = params.key_lock;
    let data = await $post('/ucenter/v2/devices/controlfc109rbypid', request);
    return Service.handleCommonError(data)
}

// 	群控FC109R表记ID列表  控制多个表计
Service.controlfc109rbytidlist = async function (params) {
    let request = {}

    // 表计id列表
    request['tidlist'] = params.tidlist

    // 	状态
    request['power_on'] = params.power_on;
    // 	模式
    request['speed'] = params.speed;
    //  模式
    request['mode'] = params.mode;
    if (params.temperature != '' && params.temperature > 0) {
        // 	设置温度
        request['temperature'] = params.temperature;
    }
    // 	通风模式使能
    request['key_lock'] = params.key_lock;

    let data = await $post('/ucenter/v2/devices/controlfc109rbytidlist', request);
    return Service.handleCommonError(data)
}

// 	群控FC109R表记ID    控制单个表计
Service.controlfc109rbytid = async function (params) {
    let request = {}

    // 表计id
    request['terminalid'] = params.terminalid

    // 	状态
    request['power_on'] = params.power_on;
    // 	模式
    request['speed'] = params.speed;
    //  模式
    request['mode'] = params.mode;
    if (params.temperature != '' && params.temperature > 0) {
        // 	设置温度
        request['temperature'] = params.temperature;
    }
    // 	通风模式使能
    request['key_lock'] = params.key_lock;

    let data = await $post('/ucenter/v2/devices/controlfc109rbytid', request);
    return Service.handleCommonError(data)
}

// 	群控FC226W表记ID    控制单个表计
Service.controlfc226wbytid = async function (params) {
    let request = {}

    // 表计id
    request['terminalid'] = params.terminalid

    // 	状态
    request['power_status'] = params.powerStatus;
    // 	模式
    request['fan_speed'] = params.fanSpeed;
    //  模式
    request['work_mode'] = params.workMode;
    if (params.roomTemperatureSp != '' && params.roomTemperatureSp > 0) {
        // 	设置温度
		if(params.temperatureMode == "F"){
			request['temperature'] = (( params.roomTemperatureSp - 32)*10 / 18);
		}else{
			request['temperature'] = (params.roomTemperatureSp)*10;
		}
        
    }
    // 	通风模式使能
    request['keyboard_lock'] = params.keyBoardlock;

    let data = await $post('/ucenter/v2/devices/controlfc226wbytid', request);
    return Service.handleCommonError(data)
}


// 	群控FC109R表记 根据建筑ID控制表计
Service.controlfc109rbymoduleidlist = async function (params) {
    let request = {}

    // 建筑ID列表
    request['moduleidlist'] = params.moduleidlist

    // 	状态
    request['power_on'] = params.power_on;
    // 	模式
    request['speed'] = params.speed;
    //  模式
    request['mode'] = params.mode;
    if (params.temperature != '' && params.temperature > 0) {
        // 	设置温度
        request['temperature'] = params.temperature * 10;
    }
    // 	通风模式使能
    request['key_lock'] = params.key_lock;

    let data = await $post('/ucenter/v2/devices/controlfc109rbymoduleidlist', request);
    return Service.handleCommonError(data)
}

// 	群控FC109R表记 根据集控器ID控制表计
Service.controlfc109rbycollectidlist = async function (params) {
    let request = {}

    // 集控器ID列表
    request['collectorlist'] = params.collectorlist

    // 	状态
    request['power_on'] = params.power_on;
    // 	模式
    request['speed'] = params.speed;
    //  模式
    request['mode'] = params.mode;
    if (params.temperature != '' && params.temperature > 0) {
        // 	设置温度
        request['temperature'] = params.temperature * 10;
    }
    // 	通风模式使能
    request['key_lock'] = params.key_lock;

    let data = await $post('/ucenter/v2/devices/controlfc109rbycollectidlist', request);
    return Service.handleCommonError(data)
}

// 	群控FC109R表记 根据设备分组控制表计
Service.controlfc109rbygroupidlist = async function (params) {
    let request = {}

    // 设备分组ID列表
    request['goupidlist'] = params.goupidlist

    // 	状态
    request['power_on'] = params.power_on;
    // 	模式
    request['speed'] = params.speed;
    //  模式
    request['mode'] = params.mode;
    if (params.temperature != '' && params.temperature > 0) {
        // 	设置温度
        request['temperature'] = params.temperature;
    }
    // 	通风模式使能
    request['key_lock'] = params.key_lock;

    let data = await $post('/ucenter/v2/devices/controlfc109rbygroupidlist', request);
    return Service.handleCommonError(data)
}

// 	计费参数
Service.controlchargingbypid = async function (params) {
    let request = {}

    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 1 允许计费；0 停止计费
    request['allow_charging'] = params.allow_charging
    // 1 调试模式；0 正常模式
    request['factory_mode'] = params.factory_mode

    let data = await $post('/ucenter/v2/devices/controlchargingbypid', request);
    return Service.handleCommonError(data)
}

//按照封盘风柜控制所有设备
Service.controlallbydevtype = async function (params) {
    let request = {}
	
	request['project_sys_id'] = Service.getProjectSystemId();
    // 设备分组ID列表
    request['devtype'] = params.devtype

    // 	状态
    request['power_status'] = params.powerStatus;
    // 	模式
    request['fan_speed'] = params.fanSpeed;
    //  模式
    request['work_mode'] = params.workMode;
    if (params.roomTemperatureSp != '' && params.roomTemperatureSp > 0) {
        // 	设置温度
        request['temperature'] = params.roomTemperatureSp * 10;
    }
    // 	通风模式使能
    request['keyboard_lock'] = params.keyBoardlock;

    let data = await $post('/ucenter/v2/devices/control/devtype', request);
    return Service.handleCommonError(data)
}

//按照组别控制所有设备
Service.controlallbygroup = async function (params) {
    let request = {}

    // 设备分组ID列表
    request['goupidlist'] = params.goupidlist

    // 	状态
    request['power_status'] = params.powerStatus;
    // 	模式
    request['fan_speed'] = params.fanSpeed;
    //  模式
    request['work_mode'] = params.workMode;
    if (params.roomTemperatureSp != '' && params.roomTemperatureSp > 0) {
        // 	设置温度
        request['temperature'] = params.roomTemperatureSp * 10;
    }
    // 	通风模式使能
    request['keyboard_lock'] = params.keyBoardlock;

    let data = await $post('/ucenter/v2/devices/control/group', request);
    return Service.handleCommonError(data)
}

//按照集控器控制所有设备
Service.controlallbycollectors = async function (params) {
    let request = {}

    // 集控器ID列表
    request['collectorlist'] = params.collectorlist

    // 	状态
    request['power_status'] = params.powerStatus;
    // 	模式
    request['fan_speed'] = params.fanSpeed;
    //  模式
    request['work_mode'] = params.workMode;
    if (params.roomTemperatureSp != '' && params.roomTemperatureSp > 0) {
        // 	设置温度
        request['temperature'] = params.roomTemperatureSp * 10; 
    }
    // 	通风模式使能
    request['keyboard_lock'] = params.keyBoardlock;

    let data = await $post('/ucenter/v2/devices/control/collectors', request);
    return Service.handleCommonError(data)
}

//根据建筑ID控制所有表计
Service.controlallbymids = async function (params) {
    let request = {}
	request['project_sys_id'] = Service.getProjectSystemId();
    // 建筑ID列表
    request['moduleidlist'] = params.moduleidlist

    // 	状态
    request['power_status'] = params.powerStatus;
    // 	模式
    request['fan_speed'] = params.fanSpeed;
    //  模式
    request['work_mode'] = params.workMode;
    if (params.roomTemperatureSp != '' && params.roomTemperatureSp > 0) {
        // 	设置温度
        request['temperature'] = params.roomTemperatureSp * 10;
    }
    // 	通风模式使能
    request['keyboard_lock'] = params.keyBoardlock;
	//是否是房间
	request['is_house'] = params.is_house;

    let data = await $post('/ucenter/v2/devices/control/mids', request);
    return Service.handleCommonError(data)
}
//控制单个表计
Service.controlmorebytid= async function (params) {
    let request = {}

    // 表计id列表
    request['terminalid'] = params.terminalid

    // 	状态
    request['power_status'] = params.powerStatus;
    // 	模式
    request['fan_speed'] = params.fanSpeed;
    //  模式
    request['work_mode'] = params.workMode;
	if(params.air_sensor_alibration){
		request['air_sensor_alibration'] = (params.air_sensor_alibration);
	}
	if(params.cooling_temperature){
		request['cooling_temperature'] = (params.roomTemperatureSp)*10;
	}else if(params.heating_temperature){
		request['heating_temperature'] = (params.roomTemperatureSp)*10;
	}else{
		if (params.roomTemperatureSp != '' && params.roomTemperatureSp > 0) {
		    // 	设置温度
		    if(params.temperatureMode == "F"){
		    	request['temperature'] = (( params.roomTemperatureSp - 32)*10 / 18);
		    }else{
		    	request['temperature'] = (params.roomTemperatureSp)*10;
		    }
		}
	}
    // 	通风模式使能
    request['keyboard_lock'] = params.keyBoardlock;

    let data = await $post('/ucenter/v2/devices/control/oid', request);
    return Service.handleCommonError(data)
}
//  控制多个表计
Service.controlmorebytidlist = async function (params) {
    let request = {}

    // 表计id列表
    request['tidlist'] = params.tidlist

    // 	状态
    request['power_status'] = params.powerStatus;
    // 	模式
    request['fan_speed'] = params.fanSpeed;
    //  模式
    request['work_mode'] = params.workMode;
    if (params.roomTemperatureSp != '' && params.roomTemperatureSp > 0) {
        // 	设置温度
        request['temperature'] = (params.roomTemperatureSp)*10;
    }
    // 	通风模式使能
    request['keyboard_lock'] = params.keyBoardlock;

    let data = await $post('/ucenter/v2/devices/control/oids', request);
    return Service.handleCommonError(data)
}
